import { render, staticRenderFns } from "./resultslist.vue?vue&type=template&id=32f27356"
import script from "./resultslist.vue?vue&type=script&lang=js"
export * from "./resultslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports